import { MinzeElement } from "minze";

export interface TjBackgroundArrowIcon {}

export class TjBackgroundArrowIcon extends MinzeElement {
  html = () => `
    <svg width="59" height="39" viewBox="0 0 59 39" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M46.6702 18.981L56.9788 30.5373M56.9788 30.5373L40.9029 36.5814M56.9788 30.5373C52.7498 28.8741 42.5382 25.7027 35.5246 26.3228C26.7576 27.0978 17.9652 32.8482 11.9666 23.2047C5.968 13.5613 17.1453 0.00040063 23.668 3.67887C30.1907 7.35734 23.0503 31.7758 7.53499 20.9173C-0.950961 14.9784 2.05386 -1.44966 7.31001 -7.57032" stroke="#068FC3" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `;

  css = () => `
    
  `;
}
